interface AgeRange {
  low_age_min?: string | null;
  low_age_max?: string | null;
  upper_age_min?: string | null;
  upper_age_max?: string | null;
}

const parseAge = (ageStr: string | null): number | null => {
  return ageStr !== null ? parseInt(ageStr, 10) : null;
};

const isWithinRange = (
  personAge: number,
  rangeMin: string | null,
  rangeMax: string | null
) => {
  const min = parseAge(rangeMin);
  const max = parseAge(rangeMax);

  if ((min !== null && personAge < min) || (max !== null && personAge > max)) {
    return false;
  }

  return true;
};

/**
 * Check if a person's age is within the specified age ranges.
 */
export const isAgeInRange = (
  personAge: number,
  ageRange: AgeRange
): boolean => {
  const { low_age_min, low_age_max, upper_age_min, upper_age_max } = ageRange;

  if (
    isWithinRange(personAge, low_age_min, low_age_max) &&
    isWithinRange(personAge, upper_age_min, upper_age_max)
  ) {
    return true;
  }

  return false;
};
